import {
    CLEAR_DIAGNOSIS_MATCH,
    CREATE_CLIENT_DIAGNOSIS,
    DELETE_CLIENT_DIAGNOSIS,
    EDIT_CLIENT_DIAGNOSIS,
    GET_CLIENT_DIAGNOSES,
    GET_DIAGNOSIS_MATCH,
    SET_PRIMARY_CLIENT_DIAGNOSIS,
} from './clientDiagnosis.types';

/** The client's diagnoses — Clinical → Diagnoses. Needs CLIENT_DIAGNOSIS_READ. */
export const getClientDiagnoses = (clientId) => ({ type: GET_CLIENT_DIAGNOSES, payload: { clientId } });

/** `body`: { code, description?, startDate, endDate?, isPrimary? }. Re-fetches the list. */
export const createClientDiagnosis = (clientId, body) => ({ type: CREATE_CLIENT_DIAGNOSIS, payload: { clientId, body } });

/** `body`: { description?, startDate?, endDate? (null clears), isPrimary? }. The code is not editable. */
export const editClientDiagnosis = (id, clientId, body) => ({ type: EDIT_CLIENT_DIAGNOSIS, payload: { id, clientId, body } });

export const setPrimaryClientDiagnosis = (id, clientId) => ({ type: SET_PRIMARY_CLIENT_DIAGNOSIS, payload: { id, clientId } });

/** Refused (409) when the code is already on a claim — the user end-dates it instead. */
export const deleteClientDiagnosis = (id, clientId) => ({ type: DELETE_CLIENT_DIAGNOSIS, payload: { id, clientId } });

/** Appointment modal preview: `params` = { clientId, authorizedServiceId, date }. */
export const getDiagnosisMatch = (params) => ({ type: GET_DIAGNOSIS_MATCH, payload: { params } });

export const clearDiagnosisMatch = () => ({ type: CLEAR_DIAGNOSIS_MATCH });
